import {
    IAdditionalMobile,
    IMainMobile,
    IUserAdditionalMobile,
    IUserBundle,
    IUserProducts,
} from '../../models/Products.interfaces';
import { IConsumption } from '../store/model/store.model';
import i18n, { t } from 'i18next';

export function addConsumptions(dataConsumptions: any, dataTab: any) {
    const cycleEnds = dataConsumptions.cycleEnds;
    const cycleStarts = dataConsumptions.cycleStarts;
    const cycleEndInDays = dataConsumptions.cycleEndInDays;
    const cycleEnded = dataConsumptions.cycleEnded;
    dataTab.forEach(function (item: any) {
        item.cycleEndInDays = cycleEndInDays;
        item.cycleStarts = cycleStarts;
        item.cycleEnds = cycleEnds;
        item.cycleEnded = cycleEnded;
        if (item.fiber) {
            let fiber = dataConsumptions.consumptions.find((x: any) => x.productPsId === item.fiber.productPsId);
            if (fiber) {
                item.fiber.extraSum = fiber.extraSum;
                item.fiber.sms = fiber.sms;
                item.fiber.voice = fiber.voice;
                item.fiber.voiceToMobile = fiber.voiceToMobile;
                item.fiber.voiceToPhone = fiber.voiceToPhone;
                item.fiber.cycleEndInDays = cycleEndInDays;
                item.fiber.cycleStarts = cycleStarts;
                item.fiber.cycleEnds = cycleEnds;
                item.fiber.cycleEnded = cycleEnded;
                item.fiber.datasharing = false;
            }
        }
        if (item.mainMobile) {
            const mainMobile = dataConsumptions.consumptions.find(
                (x: any) => x.productPsId === item.mainMobile.productPsId,
            );
            if (mainMobile) {
                item.mainMobile.data = mainMobile.data;
                item.mainMobile.dataBonus = mainMobile.dataBonus;
                item.mainMobile.extraSum = mainMobile.extraSum;
                item.mainMobile.dataSharing = mainMobile.dataSharing;
                item.mainMobile.sms = mainMobile.sms;
                item.mainMobile.voice = mainMobile.voice;
                item.mainMobile.cycleEndInDays = cycleEndInDays;
                item.mainMobile.cycleStarts = cycleStarts;
                item.mainMobile.cycleEnds = cycleEnds;
                item.mainMobile.cycleEnded = cycleEnded;
                item.mainMobile.datasharing = item.datasharing;
            }
        }
        if (item.additionalMobiles) {
            item.additionalMobiles.forEach(function (mobile: any) {
                const additionalMobile = dataConsumptions.consumptions.find(
                    (x: any) => x.productPsId === mobile.productPsId,
                );
                if (additionalMobile) {
                    mobile.data = additionalMobile.data;
                    mobile.dataBonus = additionalMobile.dataBonus;
                    mobile.extraSum = additionalMobile.extraSum;
                    mobile.sms = additionalMobile.sms;
                    mobile.dataSharing = additionalMobile.dataSharing;
                    mobile.voice = additionalMobile.voice;
                    mobile.cycleEndInDays = cycleEndInDays;
                    mobile.cycleStarts = cycleStarts;
                    mobile.cycleEnds = cycleEnds;
                    mobile.cycleEnded = cycleEnded;
                    mobile.datasharing = item.datasharing;
                }
            });
        }

        if (item.productPsId) {
            let element = dataConsumptions.consumptions.find((x: any) => x.productPsId === item.productPsId);
            if (element) {
                item.data = element.data ? element.data : '';
                item.dataBonus = element.dataBonus ? element.dataBonus : '';
                item.extraSum = element.extraSum ? element.extraSum : '';
                item.sms = element.sms ? element.sms : '';
                item.voice = element.voice;
                item.voiceToMobile = element.voiceToMobile;
                item.voiceToPhone = element.voiceToPhone;
                item.dataSharing = element.dataSharing;
                item.cycleEndInDays = cycleEndInDays;
                item.cycleStarts = cycleStarts;
                item.cycleEnds = cycleEnds;
                item.cycleEnded = cycleEnded;
                item.datasharing = false;
            }
        }
    });
    return dataTab;
}

export function addExtraSum(dataConsumptions: any, dataTab: any) {
    let datExtraSum: any = [];

    dataTab.forEach(function (item: any) {
        if (item.fiber) {
            let fiber = dataConsumptions.consumptions.find((x: any) => x.productPsId === item.fiber.productPsId);
            datExtraSum.push({
                productPsId: item.fiber.productPsId,
                number: item.fiber.number,
                extraSum: fiber.extraSum,
            });
        }
        if (item.mainMobile) {
            let mainMobile = dataConsumptions.consumptions.find(
                (x: any) => x.productPsId === item.mainMobile.productPsId,
            );
            datExtraSum.push({
                productPsId: item.mainMobile.productPsId,
                number: item.mainMobile.number,
                extraSum: mainMobile.extraSum,
            });
        }
        if (item.additionalMobiles) {
            item.additionalMobiles.forEach(function (mobile: any) {
                let additionalMobile = dataConsumptions.consumptions.find(
                    (x: any) => x.productPsId === mobile.productPsId,
                );
                datExtraSum.push({
                    productPsId: mobile.productPsId,
                    number: mobile.number,
                    extraSum: additionalMobile.extraSum,
                });
            });
        }
        if (item.productPsId) {
            let element = dataConsumptions.consumptions.find((x: any) => x.productPsId === item.productPsId);
            datExtraSum.push({ productPsId: item.productPsId, number: item.number, extraSum: element.extraSum });
        }
    });
    return datExtraSum;
}

export function addDataSharing(dataConsumptions: any, dataTab: any) {
    let dataSharing: any = [];

    dataTab.forEach(function (item: any) {
        if (item.mainMobile) {
            let mainMobile = dataConsumptions.consumptions.find(
                (x: any) => x.productPsId === item.mainMobile.productPsId,
            );
            dataSharing.push({
                productPsId: item.mainMobile.productPsId,
                number: item.mainMobile.number,
                dataShared: mainMobile.dataSharing,
                isMain: true,
            });
        }
        if (item.additionalMobiles) {
            item.additionalMobiles.forEach(function (mobile: any) {
                let additionalMobile = dataConsumptions.consumptions.find(
                    (x: any) => x.productPsId === mobile.productPsId,
                );
                dataSharing.push({
                    productPsId: mobile.productPsId,
                    number: mobile.number,
                    dataShared: additionalMobile.dataSharing,
                    isMain: false,
                });
            });
        }
    });

    return dataSharing;
}

export const getAllProductsId = (products: IUserProducts) => {
    let ids = [];
    if ('bundles' in products) {
        const _ids: string[] = products.bundles
            .map((product: IUserBundle) => {
                let _ids_: string[] = [];
                if ('additionalMobiles' in product) {
                    const _idsMobiles: string[] = product.additionalMobiles.map(
                        (mobile: IUserAdditionalMobile) => mobile.productPsId,
                    );
                    _ids_.push(..._idsMobiles);
                }

                if ('fiber' in product) {
                    const _idFiber = product.fiber.productPsId;
                    _ids_.push(_idFiber);
                }

                if ('mainMobile' in product) {
                    const _idMainMobile = product.mainMobile.productPsId;
                    _ids_.push(_idMainMobile);
                }
                return _ids_;
            })
            .flat();
        ids.push(_ids.flat());
    }

    if ('fibers' in products) {
        const _ids = products.fibers.map((product: any) => product.productPsId).flat();
        ids.push(_ids);
    }

    if ('mobiles' in products) {
        const _ids = products.mobiles.map((product: any) => product.productPsId).flat();
        ids.push(_ids);
    }

    return ids.flat();
};

export const getProducts = (dataProducts: IUserProducts) => {
    const getNameTabs = (value: any[]) => value.map((item) => item.name);
    const getItemsFromArray = (value: any[], index: number) => value.map(() => index);

    let _nameTabs: any[] = [];
    let _indexTabs: any[] = [];
    let _dataTabs: any[] = [];
    Object.entries(dataProducts).forEach((data: any) => {
        const [key, value] = data;
        if (value.length) {
            if (key === 'bundles') {
                _nameTabs.push(...getNameTabs(value));
                _dataTabs.push(value);
                _indexTabs.push(getItemsFromArray(value, 1));
            }
            if (key === 'fibers' || key === 'mobiles') {
                const keyIndex: { [key: string]: number } = {
                    fibers: 2,
                    mobiles: 3,
                };
                _nameTabs.push(...getNameTabs(value));
                _dataTabs.push(value);
                _indexTabs.push(getItemsFromArray(value, keyIndex[key]));
            }
        }
    });

    return {
        _nameTabs,
        _indexTabs,
        _dataTabs,
    };
};

export const getConsumptionById = (consumptions: IConsumption[], id: string) => {
    return consumptions
        .map((consumption: any) => {
            const { sharedData } = consumption;
            if (consumption?.fiber?.productPsId === id) {
                return { ...consumption?.fiber };
            }
            if (consumption?.mainMobile?.productPsId === id) {
                return { ...consumption.mainMobile, sharedData };
            }
            if (consumption?.additionalMobiles?.some((additional: any) => additional.productPsId === id)) {
                const consumptionAdditional = consumption.additionalMobiles.find(
                    (additional: any) => additional.productPsId === id,
                );
                return { ...consumptionAdditional, sharedData };
            }
            if (consumption?.productPsId === id) {
                return { ...consumption };
            }
        })
        .filter((product) => product)[0];
};

export const getPhoneById = (consumptions: IConsumption[], id: string) => {
    return consumptions
        .map((consumption: any) => {
            if (consumption?.fiber?.productPsId === id) {
                return consumption.fiber.number;
            }
            if (consumption?.mainMobile?.productPsId === id) {
                return consumption.mainMobile.number;
            }
            if (consumption?.additionalMobiles?.some((additional: any) => additional.productPsId === id)) {
                const additionalMobile = consumption?.additionalMobiles?.filter(
                    (additional: any) => additional.productPsId === id,
                )[0].number;
                return additionalMobile;
            }
            if (consumption?.productPsId === id) {
                return consumption.number;
            }
        })
        .filter((product) => product)[0];
};

export const getRoleLine = (consumptions: Array<IMainMobile | IAdditionalMobile> | string, id: string): string => {
    const _consumptions = typeof consumptions === 'string' ? JSON.parse(consumptions) : consumptions;
    for (const consumption of _consumptions || []) {
        if (consumption?.mainMobile?.productPsId === id || consumption?.fiber?.productPsId === id) {
            return t('breadcrumbsPrincipalLine');
        }
    }

    return t('additionalLine');
};

export const checkIfMainMobile = (consumptions: Array<IMainMobile | IAdditionalMobile> | string, id: string) => {
    const _consumptions = typeof consumptions === 'string' ? JSON.parse(consumptions) : consumptions;
    for (const consumption of _consumptions || []) {
        if (consumption?.mainMobile?.productPsId === id) {
            return true;
        }
    }

    return false;
};
